module.exports = __webpack_public_path__ + "img/self-help.d1a88ad5.svg";